import { render, staticRenderFns } from "./message_detail.vue?vue&type=template&id=42f77b74&scoped=true&"
import script from "./message_detail.vue?vue&type=script&lang=ts&"
export * from "./message_detail.vue?vue&type=script&lang=ts&"
import style0 from "./message_detail.vue?vue&type=style&index=0&id=42f77b74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f77b74",
  null
  
)

export default component.exports